export const moduleId = 'vehicleRegistration';